export class MakerCheckerConfig {
    status : any;
    start_date : string;
    end_date : string;
    limit_points : any;
    created_date : string;
  }